import { FacebookFilled, InstagramOutlined, LinkedinFilled, YoutubeFilled } from '@ant-design/icons';
import { Col, Grid, Row, Typography } from 'antd';

import availableAppStore from 'assets/images/app-store.png';
import availableGooglePlay from 'assets/images/google-play.png';
import logoEduzz from 'assets/images/logo-eduzz-blue.svg';
import { BLINKET_APP_URL } from 'settings';

import styles from './styles.module.css';

const { Text, Link } = Typography;

const { useBreakpoint } = Grid;

const Footer = () => {
  const screens = useBreakpoint();
  const sm = screens.sm === true;
  const xs = screens.xs === true;

  return (
    <div className={styles.wrapper}>
      <Row gutter={[10, 20]} align={'middle'} justify={'center'} className={styles.row}>
        <Col xs={24} lg={12} className={styles.container}>
          <img src={logoEduzz} height={30} width={100} />
          <Text className={styles.container}>
            Desde 2014 entregando {(sm || xs) && <br />} tecnologia, educação e amor.
          </Text>
          <div className={styles.icons}>
            <a href='https://www.facebook.com/eduzzbrasil' target='_blank' rel='noreferrer'>
              <FacebookFilled />
            </a>

            <a href='https://www.instagram.com/eduzzoficial' target='_blank' rel='noreferrer'>
              <InstagramOutlined />
            </a>

            <a href='https://www.youtube.com/channel/UCiHqhLhTbg8E127CDzs7MYw' target='_blank' rel='noreferrer'>
              <YoutubeFilled />
            </a>

            <a href='https://www.linkedin.com/company/eduzz' target='_blank' rel='noreferrer'>
              <LinkedinFilled />
            </a>
          </div>
          <div className={styles.apps}>
            <a
              href='https://play.google.com/store/apps/details?id=com.eduzzmobile.mobile&hl=pt_BR'
              target='_blank'
              rel='noreferrer'
            >
              <img src={availableGooglePlay} height={40} width={140} />
            </a>
            <a
              href='https://apps.apple.com/br/app/eduzz-neg%C3%B3cios-digitais/id1079845439'
              target='_blank'
              rel='noreferrer'
            >
              <img src={availableAppStore} height={40} width={140} />
            </a>
          </div>
        </Col>
        <Col xs={12} lg={6} className={styles.links}>
          <div>
            <Typography.Title level={5}>Soluções</Typography.Title>
            <div className={styles.section}>
              <Link href='https://www.eduzz.com/produtos/myeduzz' target='_blank' className={styles.textBlack}>
                MyEduzz
              </Link>
              <Link href='https://www.eduzz.com/produtos/checkout-sun' target='_blank' className={styles.textBlack}>
                Checkout Sun
              </Link>
              <Link href='https://www.eduzz.com/produtos/nutror' target='_blank' className={styles.textBlack}>
                Nutror
              </Link>
              <Link href='https://www.eduzz.com/produtos/safevideo' target='_blank' className={styles.textBlack}>
                SafeVideo
              </Link>
              <Link href='https://www.eduzz.com/produtos/blinket' target='_blank' className={styles.textBlack}>
                Blinket
              </Link>
            </div>
          </div>
        </Col>
        <Col xs={12} lg={6} className={styles.links}>
          <div>
            <Typography.Title level={5}>Educação</Typography.Title>
            <div className={styles.section}>
              <Link href={`${BLINKET_APP_URL}/event`} target='_blank' className={styles.textBlack}>
                Crie seu evento
              </Link>
              <Link href='https://academia360.eduzz.com/' target='_blank' rel='noreferrer' className={styles.textBlack}>
                {xs ? 'Primeira venda' : 'Faça sua primeira venda'}
              </Link>
              <Link href='https://blog.eduzz.com/' target='_blank' className={styles.textBlack}>
                Blog da Eduzz
              </Link>
              <Link href='https://www.youtube.com/user/eduzzbrasil' target='_blank' className={styles.textBlack}>
                {xs ? 'Youtube' : 'Nosso canal no YouTube'}
              </Link>
              <Link href={BLINKET_APP_URL} target='_blank' className={styles.textBlack}>
                {xs ? 'Gestão de eventos' : 'Faça gestão de ingressos e lotes'}
              </Link>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={24}>
          <div className={styles.bottom}>
            <div>
              <Text style={{ fontSize: '12px' }}>
                2025 © Eduzz Tecnologia LTDA - CNPJ 09.573.540/0001-39 Av. Sorocaba 500, Sorocaba/SP - CEP 18044-390
              </Text>
            </div>
            <div className={styles.bottomLinks}>
              <Link className={styles.textBlack} href='https://www.eduzz.com/legal' target='_blank'>
                Termos e Políticas
              </Link>
              <Link className={styles.textBlack} href='https://www.eduzz.com/legal' target='_blank'>
                Central de Ajuda
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
